module.exports = __webpack_public_path__ + "media/images/Contact_hand-e1c7a56f.svg";